import React from "react";
import ProductRow from "./ProductRow";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

const ProductsTable = ({
    products,
    selectedProducts,
    onSelectAll,
    onSelectProduct,
    onEdit,
    onDelete,
    onAddDiscount,
    onRemoveDiscount,
    onDirectRemoveDiscount, // New prop
    onManageDiscounts,
    getProductDiscount,
    getProductDiscounts,
    calculateDiscountedPrice,
    salesItems
}) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className="admin-table-container products-table">
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                onChange={onSelectAll}
                                checked={selectedProducts.length === products.length && products.length > 0}
                            />
                        </th>
                        <th>{t('product')}</th>
                        <th>{t('category')}</th>
                        {/* <th>Price</th> */}
                        <th>{t('stock')}</th>
                        <th>{t('status')}</th>
                        <th>{t('discount')}</th>
                        <th>{t('actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {products.length > 0 ? (
                        products.map(product => (
                            <ProductRow
                                key={product.id}
                                product={product}
                                isSelected={selectedProducts.includes(product.id)}
                                onSelect={() => onSelectProduct(product.id)}
                                onEdit={() => onEdit(product.id)}
                                onDelete={() => onDelete(product.id, product.name)}
                                onAddDiscount={() => onAddDiscount(product)}
                                onRemoveDiscount={(discountId) => onRemoveDiscount(discountId)}
                                onDirectRemoveDiscount={onDirectRemoveDiscount}
                                onManageDiscounts={onManageDiscounts}
                                getProductDiscount={getProductDiscount}
                                getProductDiscounts={getProductDiscounts}
                                calculateDiscountedPrice={calculateDiscountedPrice}
                                salesItems={salesItems}
                            />
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" className="no-results">
                                {t('noProductsFound')}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ProductsTable;